var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-dialog',{attrs:{"max-width":"800","persistent":""},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('add-passenger-to-passenger-group-form',{attrs:{"passengerGroup":_vm.passengerGroup},on:{"save":_vm.addPassenger,"close":_vm.closeDialog}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }